module.exports = __webpack_public_path__ + "static/media/joy_108.e403f8eb.ico";